export default __webpack_public_path__ + "static/media/snapchat.eed70b1d.png";